import React, { useState, useEffect } from "react";
import { FiSearch } from "react-icons/fi";
import { Link } from "react-router-dom";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import apiKey from "../../config/apiKey";
import axios from "axios";
import { toast } from "react-toastify";
import { setHitID } from "../../config/HitIDStorage";
import { FaRegTrashAlt } from "react-icons/fa";

export default function TeacherTable({ heading, header, SubHeading }) {
  // id Set
  const handleHitIDReceived = (id) => {
    setHitID(id);
  };

  // Type render function
  const renderColumnContent = (type_id) => {
    switch (type_id) {
      case 1:
        return "Home";
      case 2:
        return "Online";
      case 3:
        return "Both";
      default:
        return "Unknown";
    }
  };

  const admin = JSON.parse(localStorage.getItem("edo-admin"));

  // Update status function
  const updateStatus = async (id) => {
    try {
      const response = await fetch(
        `${apiKey}/api/edolutions/admin/updatestatusteacher/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${admin?.token}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        // console.log("Status updated successfully:", data);
        toast.success(data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          style: {
            backgroundColor: "#4FD1C5", // Customize background color
            color: "#fff", // Customize text color
          },
        });
        fetchData(); // Refresh data after update
      } else {
        const errorData = await response.json();
        console.error("Error updating status:", errorData);
        toast.error(
          "Error updating status: " + (errorData.message || "Unknown error"),
          {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          }
        );
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Error updating status.", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const [loading, setLoading] = useState(true); // Add loading state
  // Update show function
  const updateShow = async (id) => {
    try {
      const response = await fetch(
        `${apiKey}/api/edolutions/admin/updateshowteacher/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${admin?.token}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        // console.log("Status updated successfully:", data);
        toast.success(data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          style: {
            backgroundColor: "#4FD1C5", // Customize background color
            color: "#fff", // Customize text color
          },
        });
        fetchData(); // Refresh data after update
      } else {
        const errorData = await response.json();
        console.error("Error updating visibility:", errorData);
        toast.error(
          "Error updating visibility: " +
            (errorData.message || "Unknown error"),
          {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          }
        );
      }
    } catch (error) {
      console.error("Error updating visibility:", error);
      toast.error("Error updating visibility.", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  // Fetching Teachers
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("Newest");

  // const fetchData = () => {
  //   axios
  //     .get(`${apiKey}/api/edolutions/admin/users/role/2`, {
  //       headers: {
  //         Authorization: `Bearer ${admin?.token}`,
  //       },
  //     })
  //     .then((response) => {
  //       const fetchedData = response.data.map((item) => ({
  //         id: item.id,
  //         column1: item.name,
  //         column2: item.email,
  //         column3: item.phone,
  //         column4: item.type_id,
  //         column5: item.status,
  //         column6: item.visibilitycontrol,
  //         path: ".././teacherDash",
  //       }));
  //       setData(fetchedData);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data:", error);
  //     });
  // };

  const fetchData = () => {
    // Start loading before making the request
    setLoading(true);
  
    axios
      .get(`${apiKey}/api/edolutions/admin/users/role/2`, {
        headers: {
          Authorization: `Bearer ${admin?.token}`,
        },
      })
      .then((response) => {
        const fetchedData = response.data.map((item) => ({
          id: item.id,
          column1: item.name,
          column2: item.email,
          column3: item.phone,
          column4: item.type_id,
          column5: item.status,
          column6: item.visibilitycontrol,
          path: ".././teacherDash",
        }));
        
        // Set the fetched data
        setData(fetchedData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        // Set loading to false whether the request was successful or failed
        setLoading(false);
      });
  };
  
  useEffect(() => {
    fetchData();
  }, []); // Empty dependency array

  // Search and Sort
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSortChange = (e) => {
    setSortOrder(e.target.value);
  };

  const filteredData = data.filter(
    (item) =>
      item.column1.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.column2.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.column3.toLowerCase().includes(searchTerm.toLowerCase()) ||
      renderColumnContent(item.column4)
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
  );

  const sortedData = filteredData.sort((a, b) => {
    if (sortOrder === "Newest") {
      return b.id - a.id; // Assuming a higher ID is newer
    } else {
      return a.id - b.id; // Assuming a higher ID is older
    }
  });

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const totalItems = sortedData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(Math.min(Math.max(1, pageNumber), totalPages));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleItemsPerPageChange = (event) => {
    const selectedItemsPerPage = parseInt(event.target.value, 10);
    setItemsPerPage(selectedItemsPerPage);
    setCurrentPage(1); // Reset to first page
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

  // Calculate the range of pages to display
  const pageRange = [];
  const maxPageButtons = 5;
  const startPage = Math.max(1, currentPage - Math.floor(maxPageButtons / 2));
  const endPage = Math.min(totalPages, startPage + maxPageButtons - 1);

  for (let i = startPage; i <= endPage; i++) {
    pageRange.push(i);
  }

  // Soft Delete Work
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [softDeleteID, setSoftDeleteID] = useState(null);

  const handleDeleteClick = (id) => {
    setSoftDeleteID(id);
    setIsModalOpen(true);
  };

  const softDelete = async () => {
    try {
      const response = await fetch(
        `${apiKey}/api/edolutions/admin/softdeleteteacher/${softDeleteID}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${admin?.token}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        toast.success(data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          style: {
            backgroundColor: "#4FD1C5", // Customize background color
            color: "#fff", // Customize text color
          },
        });
        fetchData(); // Refresh data after update
      } else {
        const errorData = await response.json();
        console.error("Error updating visibility:", errorData);
        toast.error(
          "Error updating visibility: " +
            (errorData.message || "Unknown error"),
          {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          }
        );
      }
    } catch (error) {
      console.error("Error updating visibility:", error);
      toast.error("Error updating visibility.", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  return (
    <div className="relative max-sm:max-w-xs mx-auto  overflow-auto  my-8 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-8 border-0">
      <div className="flex flex-wrap items-center justify-between">
        <div>
          <p className="text-[22px] font-bold">{heading}</p>
          <p className="text-[14px] font-normal text-[#4FD1C5] mt-2">
            {SubHeading}
          </p>
        </div>

        <div className="flex flex-wrap gap-2 max-sm:max-w-sm mx-auto items-center">
          <div className="relative border shadow-md rounded-md flex items-center px-5 py-2">
            <FiSearch className="h-5 w-5 absolute text-black" />
            <input
              type="text"
              className="outline-none pl-8"
              placeholder="Search"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
          <div className="relative ml-2">
            <select
              className="border shadow-md rounded-md px-5 py-2 outline-none pl-2 pr-8 text-sm"
              value={sortOrder}
              onChange={handleSortChange}
            >
              <option value="Newest">Sorted By: Newest</option>
              <option value="Oldest">Sorted By: Oldest</option>
            </select>
          </div>
        </div>
      </div>

      <div className="mt-5 overflow-auto">
        <table className="w-full text-sm text-left text-gray-500 border-b table-auto">
          <thead className="text-sm text-[#B5B7C0] font-medium border-b">
            {header &&
              header.map((index) => (
                <tr key={index.head1}>
                  <th scope="col" className="py-2 px-1 w-2/12">
                    {index.head1}
                  </th>
                  <th scope="col" className="py-2 px-1 w-2/12">
                    {index.head2}
                  </th>
                  <th scope="col" className="py-2 px-1 w-2/12">
                    {index.head3}
                  </th>
                  <th scope="col" className="py-2 px-1 w-2/12">
                    {index.head4}
                  </th>
                  <th scope="col" className="py-2 px-1 w-1/12">
                    {index.head5}
                  </th>
                  <th scope="col" className="py-2 px-1 w-1/12">
                    {index.head6}
                  </th>
                  <th scope="col" className="py-2 px-1 w-1/12">
                    {index.head7}
                  </th>
                </tr>
              ))}
          </thead>
          <tbody className="text-black text-sm font-medium">
  {loading ? (
    // Show loader while data is being fetched
    <tr>
      <td colSpan="6" className="py-5 px-1 text-center">
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-200 bg-opacity-5 backdrop-blur-sm z-50">
          <div className="w-12 h-12 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-[#2DD0A5]"></div>
          <p className="mt-4 text-lg font-semibold text-[#2dd0a5]">
            Cabil...
          </p>
        </div>
      </td>
    </tr>
  ) : sortedData.length === 0 ? (
    // If no data is available and not loading, show the "No data available" message
    <tr>
      <td colSpan="6" className="py-5 px-1 text-center">
        <p className="text-gray-500">No data available</p>
      </td>
    </tr>
  ) : (
    // Show the data rows if data exists
    sortedData.slice(startIndex, endIndex).map((item) => (
      <tr key={item.id} className="border-b">
        <td>
          <Link
            to={item.path}
            onClick={() => handleHitIDReceived(item.id)}
            className="py-5 px-1 capitalize"
          >
            {item.column1}
          </Link>
        </td>
        <td className="py-5 px-1">{item.column2}</td>
        <td className="py-5 px-1">{item.column3}</td>
        <td className="py-5 px-1 flex">
          {renderColumnContent(item.column4)}
        </td>
        <td className="py-5 px-1">
          <p
            className={`border cursor-pointer shadow-lg px-5 rounded-md py-1 w-fit ${
              item.column5 === "Inactive"
                ? "text-red-500"
                : item.column5 === "Active"
                ? "text-green-500"
                : ""
            }`}
            onClick={() => updateStatus(item.id)}
          >
            {item.column5}
          </p>
        </td>
        <td className="py-5 px-1">
          <p
            className={`border cursor-pointer shadow-lg px-5 rounded-md py-1 w-fit ${
              item.column6 === "Hide"
                ? "text-red-500"
                : item.column6 === "Unhide"
                ? "text-green-500"
                : ""
            }`}
            onClick={() => updateShow(item.id)}
          >
            {item.column6}
          </p>
        </td>
        <td className="py-5 text-center">
          <button
            className="text-red-500 text-[20px]"
            onClick={() => handleDeleteClick(item.id)}
          >
            <FaRegTrashAlt />
          </button>
        </td>
      </tr>
    ))
  )}
</tbody>

        </table>

        {/* Pagination */}
        <div className="flex flex-wrap gap-5 justify-between items-center w-full text-sm mt-4 pb-4 px-2">
          <div className="flex items-center gap-x-2 text-gray-400">
            <span>
              <select
                className="text-sm border-none text-black bg-[#F5F5F5] rounded-lg"
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
              >
                {[10, 20, 30, 40, 50, 100].map((perPage) => (
                  <option key={perPage} value={perPage}>
                    {perPage}
                  </option>
                ))}
              </select>
            </span>
            <span>Showing Data</span>
            <span>
              {startIndex + 1}-{endIndex} of {totalItems} Entries
            </span>
          </div>

          <div className="flex items-center gap-x-2 text-gray-400">
            <button
              className="text-base text-black bg-[#F5F5F5] rounded-lg px-2 py-1"
              onClick={handlePrevPage}
              disabled={currentPage === 1}
            >
              <MdKeyboardArrowLeft />
            </button>

            <div className="flex items-center gap-x-2 text-gray-400">
              {pageRange.map((pageNumber) => {
                const isActive = pageNumber === currentPage;
                return (
                  <button
                    key={pageNumber}
                    className={`text-base rounded-lg px-3 py-1 ${
                      isActive
                        ? "text-white bg-[#4FD1C5]"
                        : "text-black bg-[#F5F5F5]"
                    }`}
                    onClick={() => handlePageChange(pageNumber)}
                    disabled={pageNumber < 1 || pageNumber > totalPages}
                  >
                    {pageNumber}
                  </button>
                );
              })}
              <span>of {totalPages || 1} pages</span>
            </div>

            <button
              className="text-base text-black bg-[#F5F5F5] rounded-lg px-2 py-1"
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              <MdKeyboardArrowRight />
            </button>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-300 bg-opacity-80">
          <div className="bg-white p-6 rounded-md shadow-md">
            <p className="text-lg font-semibold mb-4">
            This action will permanently remove the teacher's data. <br /> Are you sure you want to proceed?
            </p>
            <div className="flex justify-end">
              <button
                onClick={() => setIsModalOpen(false)}
                className="mr-4 bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  softDelete(softDeleteID);
                  setIsModalOpen(false);
                }}
                className="bg-red-500 text-white px-4 py-2 rounded-md"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
